module.exports = __webpack_public_path__ + "media/images/icon__point--text@3x-c73c238af3f601861cbe07b371c36aee.png";